<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changeInfoManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tài khoản bên cạnh ảnh đại diện, rồi nhấn vào icon [Thông tin cá nhân].</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeInfoManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào thanh [Thông tin cá nhân], thì các thông tin sẽ được hiển thị như bên dưới.</p>
                    <p>③ Nếu muốn chỉnh sửa, nhấn vào nút [Chỉnh sửa] ở góc dưới bên phải màn hình.</p>
                </div>
                <div><img src="/static\images\vi\newManual\changeInfoManual-3.png" alt="" /></div>
                <div>
                    <p>④ Ngoại trừ tên và ngày tháng năm sinh, học viên có thể tự chỉnh sửa các thông tin cá nhân khác nếu cần.</p>
                    <p>⑤ Sau đó, nhấn nút [Lưu].</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\update_info_1.png" alt="" /></div>
                <div><p>② Nhấn vào nút [Thông tin cá nhân].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\update_info_2.png" alt="" /></div>
                <div><p>③ Nhấn vào nút [chỉnh sửa] trong phần thông tin cá nhân.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\update_info_3.png" alt="" /></div>
                <div><p>④ Xuất hiện chỗ thay đổi thông tin. Khi hoàn thành thay đổi thông tin bạn hãy nhấn nút [Lưu].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\update_info_4.png" alt="" /></div>
                <div><p>⑤ Thông tin thay đổi của bạn đã được cập nhật.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\update_info_5.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/changeInfo_manual.vue